export default {
	favorite_delete_dialog_cancel: 'Cancel',
	favorite_delete_dialog_confirm: 'Delete',
	favorite_delete_dialog_message: 'Do you really want to delete this shortcut?',
	favorite_delete_dialog_title: 'Delete shortcut',
	favorite_dialog_button_color: 'Button color',
	favorite_dialog_button_label: 'Button label',
	favorite_dialog_button_label_placeholder: 'e.g. Important emails',
	favorite_dialog_cancel: 'Cancel',
	favorite_dialog_color_tab_extended: 'Extended',
	favorite_dialog_color_tab_gradient: 'Gradient',
	favorite_dialog_color_tab_palette: 'Palette',
	favorite_dialog_color_tab_rgb: 'RGB',
	favorite_dialog_color_tab_standard: 'Standard',
	favorite_dialog_display_in_results: 'Display in search results',
	favorite_dialog_display_inline_explanation: 'Shortcut replaces matching text parts directly in text',
	favorite_dialog_display_mode_inline: 'Replace inline',
	favorite_dialog_display_mode_none: 'Do not display',
	favorite_dialog_display_mode_separate: 'Separate area',
	favorite_dialog_display_none_explanation: 'Shortcut will not be displayed in search results',
	favorite_dialog_display_separate_explanation: 'Shortcut will be displayed as separate chip in large view',
	favorite_dialog_hex_value: 'Hex value',
	favorite_dialog_preview: 'Preview:',
	favorite_dialog_save: 'Save as shortcut',
	favorite_dialog_search_term_label: 'Search term',
	favorite_dialog_title: 'Save search as shortcut',
	favorite_display_disabled_explanation: 'Pure exclusion filters cannot be displayed in results',
	filter_component_active_users: 'Active users',
	filter_component_box_invalid_tooltip: 'Box has no valid ID and cannot be filtered',
	filter_component_boxes_filter: 'Boxes',
	filter_component_boxes_placeholder: 'All boxes',
	filter_component_boxes_selected: '{count} selected',
	filter_component_clear_all_filters: 'Clear all filters',
	filter_component_custom_range: 'Custom…',
	filter_component_direction_filter: 'Direction',
	filter_component_inactive_users: 'Deactivated users',
	filter_component_label: 'Filter',
	filter_component_list_filter: 'Lists',
	filter_component_module_filter: 'Modules',
	filter_component_none: 'None',
	filter_component_select_all: 'All',
	filter_component_this_month: 'This month',
	filter_component_this_week: 'This week',
	filter_component_timerange_filter: 'Timerange',
	filter_component_today: 'Today',
	filter_component_unknown_user: 'User {id}',
	filter_component_user_filter: 'User',
	filter_component_users_placeholder: 'All users',
	filter_component_users_search_empty: 'No user found',
	filter_component_users_search_placeholder: 'Search users…',
	filter_component_users_selected: '{count} selected',
	filter_component_virtual_groups: 'Virtual groups',
	filter_component_yesterday: 'Yesterday',
	filter_mobile_no_list: 'No list',
	search_clear_all_tooltip: 'Clear all (favorites and search term)',
	search_clear_favorites_tooltip: 'Clear favorites',
	search_clear_tooltip: 'Clear search text',
	search_history_clear_all: 'Clear all searches',
	search_history_clear_tooltip: 'Clear search history for this module',
	search_history_days_ago: '{days} day ago',
	search_history_days_ago_plural: '{days} days ago',
	search_history_hours_ago: '{hours} hrs ago',
	search_history_just_now: 'Just now',
	search_history_minutes_ago: '{minutes} min ago',
	search_history_no_entries_tooltip: 'No search history available',
	search_history_open_tooltip: 'Open search history ({count} entries)',
	search_history_recent_searches: 'Recent searches',
	search_in_instance_placeholder: 'Search in {name}...',
	search_placeholder_agenda: 'Search appointments...',
	search_placeholder_default: 'Search...',
	search_placeholder_documents: 'Search documents...',
	search_placeholder_ido_activity_history: 'Search record history...',
	search_placeholder_inbox: 'Search inbox...',
	search_placeholder_mails: 'Search emails...',
	search_placeholder_messages: 'Search messages...',
	search_placeholder_notes: 'Search notes...',
	search_placeholder_phonecalls: 'Search phone calls...',
	search_placeholder_records: 'Search across all records...',
	search_placeholder_tasks: 'Search tasks...',
	search_placeholder_trash: 'Search trash...',
	shortcut_add_to_shortcuts: 'Add to shortcuts',
	shortcut_edit: 'Edit shortcut',
	shortcut_picker_filter_placeholder: 'Search shortcuts...',
	shortcut_picker_label: 'Shortcuts',
	shortcut_picker_no_results: 'No shortcuts found',
	shortcut_picker_row_menu_label: 'Options',
	shortcut_remove_from_shortcuts: 'Remove from shortcuts',
	shortcut_sync_error: 'Shortcuts could not be synchronized with the server. Changes will only be saved locally.',
};
